import React from "react"
import RelationshipSimple from "./RelationshipSimple";
import RelationshipCar from "../../../mtska-frontend-modules/modules/Car/views/RelationshipCar";
import RelationshipSetup from "./RelationshipSetup";
import RelationshipFileGeneric from "./RelationshipFileGeneric";
import RelationshipPerson from './RelationshipPerson';
import RelationshipEmployment from './RelationshipEmployment';
import RelationshipEmployments from './RelationshipEmployments';
import RelationshipEmploymentsWithPerson from './RelationshipEmploymentsWithPerson';
import RelationshipDriverDelegate from "./RelationshipDriverDelegate";
import RelationshipService from "./RelationshipService";
import RelationshipLegalEntity from "./RelationshipLegalEntity";
import RelationshipTraceKm from "./RelationshipTraceKm";
import RelationshipTyreSet from "./RelationshipTyreSet";
import RelationshipContract from "../../../mtska-frontend-modules/modules/Contract/views/RelationshipContract";
import RelationshipPool from "./RelationshipPool";
import RelationshipFringeBenefitCar from "./RelationshipFringeBenefitCar";
import RelationshipFringeBenefitValue from "./RelationshipFringeBenefitValue";
import RelationshipAttributionRule from "./RelationshipAttributionRule";
import RelationshipCashFlowRecordGroup from "./RelationshipCashFlowRecordGroup";
import RelationshipContoEconomicoRecordGroup from "./RelationshipContoEconomicoRecordGroup";
import RelationshipContoEconomicoRecord from "./RelationshipContoEconomicoRecord";
import RelationshipCarCalendar from "./RelationshipCarCalendar";

import { Checkbox, List, ListItem, ListItemContent } from "@mui/joy";
import { useTranslation } from 'react-i18next'
import RelationshipSaltEdgeAccount from "./RelationshipSaltEdgeAccount";
import RelationshipSaltEdgeConnection from "./RelationshipSaltEdgeConnection";
import RelationshipAudienceLead from "./RelationshipAudienceLead";
import RelationshipAudienceCheck from "./RelationshipAudienceCheck";
import RelationshipDelivery from "./RelationshipDelivery";
import RelationshipRuleset from "./RelationshipRuleset";

import { DndContext } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { useSortable } from '@dnd-kit/sortable';
import { arrayMove } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import JSONPretty from 'react-json-pretty';
import RelationshipRulesetWithDeal from "./RelationshipRulesetWithDeal";
import RelationshipCommissionInvoiceRow from "./RelationshipCommissionInvoiceRow";

const sortableActive = false;

const Relationship = ({ view = 'simple', value, name, editing, visiblelimit, handleItemDetail, handleItemRemove, relation, callback, setValue, checkable, checked, onCheckChange, loadingDissociation }) => {
    const { t, i18n } = useTranslation();

    const getItem = (v, k) => {
        let item;
        switch (view) {
            case 'car':
                item = <RelationshipCar
                    k={k}
                    v={v}
                    name={name}
                    editing={editing}
                    handleItemDetail={handleItemDetail}
                    handleItemRemove={handleItemRemove}
                    loadingDissociation={loadingDissociation}
                />
                break;
            case 'carcalendar':
                item = <RelationshipCarCalendar
                    k={k}
                    v={v}
                    name={name}
                    editing={editing}
                    handleItemDetail={handleItemDetail}
                    handleItemRemove={handleItemRemove}
                    loadingDissociation={loadingDissociation}
                />
                break;
            case 'setup':
                item = <RelationshipSetup
                    k={k}
                    v={v}
                    name={name}
                    editing={editing}
                    handleItemDetail={handleItemDetail}
                    handleItemRemove={handleItemRemove}
                    loadingDissociation={loadingDissociation}
                />
                break;
            case 'fringebenefitcar':
                item = <RelationshipFringeBenefitCar
                    k={k}
                    v={v}
                    name={name}
                    editing={editing}
                    handleItemDetail={handleItemDetail}
                    handleItemRemove={handleItemRemove}
                    loadingDissociation={loadingDissociation}
                />
                break;
            case 'fringebenefitvalue':
                item = <RelationshipFringeBenefitValue
                    k={k}
                    v={v}
                    name={name}
                    editing={editing}
                    handleItemDetail={handleItemDetail}
                    handleItemRemove={handleItemRemove}
                    loadingDissociation={loadingDissociation}
                />
                break;
            case 'contract':
                item = <RelationshipContract
                    k={k}
                    v={v}
                    name={name}
                    editing={editing}
                    handleItemDetail={handleItemDetail}
                    handleItemRemove={handleItemRemove}
                    loadingDissociation={loadingDissociation}
                />
                break;
            case 'pool':
                item = <RelationshipPool
                    k={k}
                    v={v}
                    name={name}
                    editing={editing}
                    handleItemDetail={handleItemDetail}
                    handleItemRemove={handleItemRemove}
                    loadingDissociation={loadingDissociation}
                />
                break;
            case 'legalEntity':
                item = <RelationshipLegalEntity
                    k={k}
                    v={v}
                    name={name}
                    editing={editing}
                    handleItemDetail={handleItemDetail}
                    handleItemRemove={handleItemRemove}
                    loadingDissociation={loadingDissociation}
                />
                break;
            case 'fileGeneric':
            case 'document':
            case 'documents':
            case 'picture':
                item = <RelationshipFileGeneric
                    k={k}
                    v={v}
                    name={name}
                    editing={editing}
                    handleItemDetail={handleItemDetail}
                    handleItemRemove={handleItemRemove}
                    loadingDissociation={loadingDissociation}
                />
                break;
            case 'driverdelegate':
                item = <RelationshipDriverDelegate
                    k={k}
                    v={v}
                    name={name}
                    editing={editing}
                    handleItemDetail={handleItemDetail}
                    handleItemRemove={handleItemRemove}
                    loadingDissociation={loadingDissociation}
                />
                break;
            case 'service':
                item = <RelationshipService
                    k={k}
                    v={v}
                    name={name}
                    editing={editing}
                    handleItemDetail={handleItemDetail}
                    handleItemRemove={handleItemRemove}
                    loadingDissociation={loadingDissociation}
                />
                break;
            case 'person':
                item = <RelationshipPerson
                    callback={callback}
                    filters={value}
                    relation={relation}
                    k={k}
                    v={v}
                    name={name}
                    editing={editing}
                    handleItemDetail={handleItemDetail}
                    handleItemRemove={handleItemRemove}
                    loadingDissociation={loadingDissociation}
                />
                break;
            case 'employment':
                item = <RelationshipEmployment
                    callback={callback}
                    filters={value}
                    relation={relation}
                    k={k}
                    v={v}
                    name={name}
                    editing={editing}
                    handleItemDetail={handleItemDetail}
                    handleItemRemove={handleItemRemove}
                    loadingDissociation={loadingDissociation}
                    setValue={setValue}
                />
                break;
            case 'employments':
                item = <RelationshipEmployments
                    callback={callback}
                    filters={value}
                    relation={relation}
                    k={k}
                    v={v}
                    name={name}
                    editing={editing}
                    handleItemDetail={handleItemDetail}
                    handleItemRemove={handleItemRemove}
                    loadingDissociation={loadingDissociation}
                />
                break;
            case 'employmentsWithPerson':
                item = <RelationshipEmploymentsWithPerson
                    callback={callback}
                    filters={value}
                    relation={relation}
                    k={k}
                    v={v}
                    name={name}
                    editing={editing}
                    handleItemDetail={handleItemDetail}
                    handleItemRemove={handleItemRemove}
                    loadingDissociation={loadingDissociation}
                />
                break;
            case 'traceKm':
            case 'traceKms':
                item = <RelationshipTraceKm
                    k={k}
                    v={v}
                    name={name}
                    editing={editing}
                    handleItemDetail={handleItemDetail}
                    handleItemRemove={handleItemRemove}
                    loadingDissociation={loadingDissociation}
                />
                break;
            case 'tyreSet':
                item = <RelationshipTyreSet
                    k={k}
                    v={v}
                    name={name}
                    editing={editing}
                    handleItemDetail={handleItemDetail}
                    handleItemRemove={handleItemRemove}
                    loadingDissociation={loadingDissociation}
                />
                break;
            case 'saltedgeconnection':
                item = <RelationshipSaltEdgeConnection
                    k={k}
                    v={v}
                    name={name}
                    editing={editing}
                    handleItemDetail={handleItemDetail}
                    handleItemRemove={handleItemRemove}
                    loadingDissociation={loadingDissociation}
                />
                break;
            case 'saltedgeaccount':
                item = <RelationshipSaltEdgeAccount
                    k={k}
                    v={v}
                    name={name}
                    editing={editing}
                    handleItemDetail={handleItemDetail}
                    handleItemRemove={handleItemRemove}
                    loadingDissociation={loadingDissociation}
                />
                break;
            case 'attributionrule':
                item = <RelationshipAttributionRule
                    k={k}
                    v={v}
                    name={name}
                    editing={editing}
                    handleItemDetail={handleItemDetail}
                    handleItemRemove={handleItemRemove}
                    loadingDissociation={loadingDissociation}
                />
                break;
            case 'contoeconomicorecordgroup':
                item = <RelationshipContoEconomicoRecordGroup
                    k={k}
                    v={v}
                    name={name}
                    editing={editing}
                    handleItemDetail={handleItemDetail}
                    handleItemRemove={handleItemRemove}
                    loadingDissociation={loadingDissociation}
                />
                break;
            case 'contoeconomicorecord':
                item = <RelationshipContoEconomicoRecord
                    k={k}
                    v={v}
                    name={name}
                    editing={editing}
                    handleItemDetail={handleItemDetail}
                    handleItemRemove={handleItemRemove}
                    loadingDissociation={loadingDissociation}
                />
                break;
            case 'cashflowrecordgroup':
                item = <RelationshipCashFlowRecordGroup
                    k={k}
                    v={v}
                    name={name}
                    editing={editing}
                    handleItemDetail={handleItemDetail}
                    handleItemRemove={handleItemRemove}
                    loadingDissociation={loadingDissociation}
                />
                break;
            case 'audienceLead':
                item = <RelationshipAudienceLead
                    k={k}
                    v={v}
                    name={name}
                    editing={editing}
                // handleItemDetail={handleItemDetail}
                // handleItemRemove={handleItemRemove}
                // loadingDissociation={loadingDissociation}
                />
                break;
            case 'audienceCheck':
                item = <RelationshipAudienceCheck
                    k={k}
                    v={v}
                    name={name}
                    editing={editing}
                // handleItemDetail={handleItemDetail}
                // handleItemRemove={handleItemRemove}
                // loadingDissociation={loadingDissociation}
                />
                break;
            case 'delivery':
                item = <RelationshipDelivery
                    k={k}
                    v={v}
                    name={name}
                    editing={editing}
                    handleItemDetail={handleItemDetail}
                // handleItemRemove={handleItemRemove}
                // loadingDissociation={loadingDissociation}
                />
                break;
            case 'ruleset':
                item = <RelationshipRuleset
                    k={k}
                    v={v}
                    name={name}
                    editing={editing}
                    handleItemDetail={handleItemDetail}
                    handleItemRemove={handleItemRemove}
                    loadingDissociation={loadingDissociation}
                />
                break;
            case 'rulesetWithDeal':
                item = <RelationshipRulesetWithDeal
                    k={k}
                    v={v}
                    name={name}
                    editing={editing}
                    handleItemDetail={handleItemDetail}
                    handleItemRemove={handleItemRemove}
                    loadingDissociation={loadingDissociation}
                />
                break;
            case 'commissioninvoicerow':
                item = <RelationshipCommissionInvoiceRow
                    k={k}
                    v={v}
                    name={name}
                    editing={editing}
                    handleItemDetail={handleItemDetail}
                    handleItemRemove={handleItemRemove}
                    loadingDissociation={loadingDissociation}
                />
                break;
            default:
                item = <RelationshipSimple
                    k={k}
                    v={v}
                    name={name}
                    view={view}
                    editing={editing}
                    handleItemDetail={handleItemDetail}
                    handleItemRemove={handleItemRemove}
                    loadingDissociation={loadingDissociation}
                />
        }

        if (checkable) {
            return <ListItem sx={{ display: 'grid', gridTemplateColumns: '30px auto' }} className="relationship-checkable"><Checkbox onChange={onCheckChange} value={v._id} />{item}</ListItem>
        } else if (sortableActive && relation.sortable) {
            return <SortableListItem key={v._id} id={v._id}>{item}</SortableListItem>
        } else {
            return item;
        }
    }


    let items;
    if (Array.isArray(value)) {
        items = value.map((v, k) => {
            if (k >= visiblelimit) return;
            return getItem(v, k);
        })
    } else if (typeof value === 'object' && value !== null) {
        items = getItem(value, 1);
    }

    const ListContent = (
        <>
            {/* <JSONPretty data={value} className={'json-wrapper'} /> */}
            <List variant="plain" className={"relationship-elements relationship-elements-" + view}>
                {items}
                {(!editing && !items) && (
                    <ListItem variant="plain">
                        <ListItemContent>{t('none')}</ListItemContent>
                    </ListItem>
                )}
            </List>
        </>
    );

    const handleDragEnd = (event) => {
        const { active, over } = event;

        if (active.id !== over?.id) {
            const oldIndex = value.findIndex(item => item._id === active.id);
            const newIndex = value.findIndex(item => item._id === over.id);

            const newValue = arrayMove(value, oldIndex, newIndex);
            console.info(newValue)
        }
    };

    return sortableActive && relation.sortable ? (
        <DndContext onDragEnd={handleDragEnd}>
            <SortableContext items={value.map(item => item._id)} strategy={verticalListSortingStrategy}>
                {ListContent}
            </SortableContext>
        </DndContext>
    ) : (
        ListContent
    );
};

const SortableListItem = ({ id, children }) => {
    const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
    };

    return (
        <ListItem
            ref={setNodeRef}
            style={style}
            {...attributes}
            {...listeners}
        >
            {children}
        </ListItem>
    );
};

export default Relationship
